import { Card } from '@chakra-ui/react';
import { IoWarning } from 'react-icons/io5';
import styled from 'styled-components';


const AutoLogoutBannerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
`;

const AutoLogoutBanner = styled(Card)`
  padding: 25px;
`;

const Message = styled.div`
  font-size: 20px;
`;

const WarningIcon = styled(IoWarning)`
  font-size: 50px;
  margin-right: 40px;
  
  path {
    fill: orange;
  }
`;

const Strong = styled.strong`
  display: inline-block;
  width: 27px; /* Fixed width for 2 digits to avoid text movement */
  text-align: center;
  font-weight: 700;
  color: orange;
`;

export default {
    AutoLogoutBannerWrapper,
    AutoLogoutBanner,
    Message,
    WarningIcon,
    Strong,
};
